import React, { Fragment, useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { roleOperations } from './../../state/ducks/role';

import { Table } from 'app/components';

import { Link } from 'react-router-dom';

import Fab from '@material-ui/core/Fab';

import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteIcon from '@material-ui/icons/Delete';

import { openSnackbar } from 'app/components/snackbar';

import utils from 'app/utils';

const RolesPage = () => {

    /**
     * Take dispatch from react-redux
     */
    const dispatch = useDispatch();

    /**
     * Search for roles via Api
     */
    const search = useCallback( query => dispatch( roleOperations.search( 'roles', query ) ), [ dispatch ] );

    /**
     * Remove role via Api
     */
    const remove = useCallback( id => dispatch( roleOperations.remove( 'roles', id ) ), [ dispatch ] );

    /**
     * Roles blrf object
     */
    const rolesObject = useSelector( state => state.app.blrf.objects.roles || state.app.blrf.defaultObject );

    const { data, meta } = useMemo( () => {
        return {
            data: rolesObject.data,
            meta: rolesObject.meta
        }
    }, [ rolesObject ]);

    const query = useMemo( () => {
        /**
         * When object is first created query will only contain { refs: 0, page: 1 }
         *
         * We don't want refs, so we change that. And we want to have default order.
         * All other aspects of query object is controlled via
         * Table component.
         */
         const hasOrder = Array.isArray(rolesObject.query.order) && rolesObject.query.order.length > 0;
         if (rolesObject.query.refs === 1 || !hasOrder) {
            return { ...rolesObject.query, refs: 0, order: (hasOrder ? [...rolesObject.query.order ] : ['name ASC'] ) };
         }
         return rolesObject.query;
    }, [ rolesObject.query ] );

    const {
        loading,
        error
    } = rolesObject;

    const fields = [
        {
            label: 'Id',
            name: 'id',
            type: 'number',
            width: 1,
        },
        {
            label: 'Name',
            name: 'name',
            width: 3,
        },
        {
            label: 'Description',
            name: 'description',
            width: 8
        }
    ];

    const renderRow = ({ id, name, description }, i) => ({
        key: id,
        cells: [
            id,
            name,
            description
        ]
    });

    const actions = [
        {
            icon: <DescriptionIcon />,
            component: Link,
            to: utils.getFullPath('admin/roles/view/:id')
        },
        {
            icon: <CreateIcon />,
            component: Link,
            to: utils.getFullPath('admin/roles/edit/:id')
        },
        {
            icon: <DeleteIcon />,
            onClick: ( data ) => removeRole(data.id),
            confirm: {
                content: 'Are you sure you want to delete role :name ?'
            }
        }
    ];

    const removeRole = async ( id ) => {
        const ret = await remove( id );
        if (ret.type.indexOf('error') > 0) {
            openSnackbar('Failed to delete role', 'error');
        } else {
            openSnackbar('Role deleted', 'success');
            search( query );
        }
    }

    return (
        <Fragment>
            <Table
                fields={fields}
                renderRow={renderRow}
                actions={actions}
                loading={loading}
                search={search}
                query={query}
                data={data}
                meta={meta}
                error={error}
                />
            <Fab color='primary' style={{ float: 'right' }} variant='extended' component={Link} to={utils.getFullPath('admin/roles/add')}>
                <AddIcon />
                Add role
            </Fab>
        </Fragment>
    );
};

export default RolesPage;
